<template>
  <g>
    <path fill="url(#dropped-line-linear-gradient)"
          :class="{ dim: !!thruData }"
          :d="pathDescription"
          :transform="`translate(${translate[0]}, ${translate[1]}) scale(${scale})`" />
    <path v-if="thruData"
          fill="url(#dropped-line-linear-gradient)"
          :d="pathDescriptionThru"
          :transform="`translate(${translate[0]}, ${translate[1]}) scale(${scaleThru})`" />
  </g>
</template>

<script>
const minHeight = 25
const defaultHeight = 41.8

export default {
  name: 'BaNodeDropoffPath',
  components: {
  },
  props: {
    nodeData: {
      type: Object,
      required: true
    },
    thruData: {
      type: Object
    },
    layout: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    predefined () {
      return this.nodeData._dropPathInfo
    },
    translate () {
      if (this.predefined) {
        return [10 + 10 * this.scale, this.height]
      }
      return [10, this.layout.height]
    },
    height () {
      if (this.predefined) {
        return this.predefined.width
      }
      const nodeData = this.nodeData
      const dropCnt = this.nodeData.dropCnt || 0
      return this.layout.height * dropCnt / (nodeData._realOutSessCnt || nodeData.sessCnt)
    },
    scale () {
      return Math.max(0.1, Math.min(1, this.height / minHeight))
    },
    pathDescription () {
      const calcTop = defaultHeight - (this.scale < 1 ? minHeight : this.height)
      return this.generateDescription(this.scale, calcTop)
    },
    heightThru () {
      const nodeData = this.nodeData
      const dropCnt = this.thruData.dropCnt || 0
      return this.layout.height * dropCnt / (nodeData._realOutSessCnt || nodeData.sessCnt)
    },
    scaleThru () {
      return Math.max(0.1, Math.min(1, this.heightThru / minHeight))
    },
    pathDescriptionThru () {
      const calcTop = defaultHeight - (this.scaleThru < 1 ? minHeight : this.heightThru)
      return this.generateDescription(this.scaleThru, calcTop)
    }
  },
  methods: {
    calculateTop (value, calcTop) {
      return value.split(' ').map((points) => {
        return points.split(',').map((point, index) => {
          return parseFloat(point) + (index === 0 ? 0 : calcTop)
        })
      })
    },
    calculateTail (x, y, scale, adjustX = 1) {
      const factor = Math.max(0, 1 - (scale - 0.1) * 8)
      x = x + 19 * factor * adjustX
      y = y + 100 * factor
      return x + ',' + y
    },
    generateDescription (scale, calcTop) {
      const description = []
      const adjustXValue = 3
      description.push(
        'M' + this.calculateTail(30.162201, 79, scale, adjustXValue),
        'C' + this.calculateTail(21.419800, 59.709320, scale) + ' 11.160187,33 7.260834,19',
        'C3.361481,5 0,0 -10,0',
        'C' + this.calculateTop('-10,-8.372055 -10,35.146082 -10,-41.724304', calcTop),
        'C' + this.calculateTop('-7.003784,-41.724304 -3.670451,-41.724304 0,-41.724304', calcTop),
        'C' + this.calculateTop('15.272278,-41.724304 20,-33.759827 20,-15.276184', calcTop),
        'C' + this.calculateTop('20,-31.293416 20,-30.351355 20,-12.45', calcTop * 0.8),
        'C20,4 21.539177,14.625441 22.754456,20.070638',
        'C25.736137,33.430411 ' + this.calculateTail(30.127738, 51.136351, scale) + ' ' + this.calculateTail(39.249288, 75.224886, scale, adjustXValue),
        'C' + this.calculateTail(36.090881, 76.800491, scale, adjustXValue) + ' ' + this.calculateTail(33.711258, 77.846069, scale, adjustXValue) + ' ' + this.calculateTail(30.162201, 79, scale, adjustXValue),
        'Z'
      )
      return description.join(' ')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
